import { Reveal } from "@/components/Reveal";

const LEVELS = [
  { name: "Eau de Toilette", pct: "5–15%", note: "Typical high-street", width: "30%", dim: true },
  { name: "Eau de Parfum", pct: "15–20%", note: "Typical designer", width: "55%", dim: true },
  { name: "Reserve 30 Parfum", pct: "25–30%", note: "Our standard", width: "92%", dim: false },
];

export default function ConcentrationSection() {
  return (
    <section data-testid="concentration-section" className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32">
      <div className="grid md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-5">
          <p className="overline-label">Concentration</p>
          <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4 leading-tight">
            Parfum strength.<br />Nothing less.
          </h2>
          <p className="mt-6 text-sm md:text-base text-black/60 leading-relaxed max-w-sm">
            Concentration decides how a fragrance lives on skin. We bottle exclusively at extrait de parfum levels — the highest tier of the perfumer's craft.
          </p>
        </Reveal>
        <div className="md:col-span-6 md:col-start-7 space-y-10 self-center">
          {LEVELS.map((l, i) => (
            <Reveal key={l.name} delay={i * 0.12}>
              <div className="flex items-baseline justify-between mb-3">
                <span className={`text-sm tracking-wide ${l.dim ? "text-black/40" : "font-medium"}`}>{l.name}</span>
                <span className={`font-serif-brand text-2xl ${l.dim ? "text-black/40" : "text-[#BA8D53]"}`}>{l.pct}</span>
              </div>
              <div className="h-px bg-black/10 relative">
                <div
                  className={`absolute left-0 top-0 h-px ${l.dim ? "bg-black/30" : "bg-[#BA8D53] h-[3px] -top-[1px]"}`}
                  style={{ width: l.width }}
                />
              </div>
              <p className="mt-2 text-[0.65rem] uppercase tracking-[0.24em] text-black/40">{l.note}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
